import "css!js/file_viewer/ui/fullscreen_right_section.module.out.css";
export const fullscreenRightSection = "_fullscreenRightSection_k1zqn_5";
export const hidden = "_hidden_k1zqn_16";
const classes = { "fullscreenRightSection": "_fullscreenRightSection_k1zqn_5", "hidden": "_hidden_k1zqn_16" };
export default classes;
//# sourceMappingURL=fullscreen_right_section.module.css.preenvesnextjs.map
